import PropTypes from "prop-types";
import { getRoleLabel } from "utils/roleLabels";
import { formatDateTime } from "utils/formatDate";

export default function DeletedUsersDataTable({ users, t, language = "fr" }) {
  // Define columns with translation support
  const columns = [
    {
      Header: t ? t("superAdmin.deletedUsers.table.columns.name", "Name") : "Name",
      accessor: "first_name",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.deletedUsers.table.columns.role", "Role") : "Role",
      accessor: "role",
      Cell: ({ value }) => getRoleLabel(value, t),
    },
    {
      Header: t
        ? t("superAdmin.deletedUsers.table.columns.phoneNumber", "Phone Number")
        : "Phone Number",
      accessor: "phone_number",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.deletedUsers.table.columns.email", "Email") : "Email",
      accessor: "email_id",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.deletedUsers.table.columns.state", "Department") : "Department",
      accessor: "state",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.deletedUsers.table.columns.district", "IEF") : "IEF",
      accessor: "district",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t
        ? t("superAdmin.deletedUsers.table.columns.created_by", "Created By")
        : "Created By",
      accessor: "created_by",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t
        ? t("superAdmin.deletedUsers.table.columns.deleted_by", "Deleted By")
        : "Deleted By",
      accessor: "deleted_by",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t
        ? t("superAdmin.deletedUsers.table.columns.deleted_date", "Deleted At")
        : "Deleted At",
      accessor: "deleted_date",
      Cell: ({ value }) => {
        if (!value) return "-";
        return formatDateTime(value, language);
      },
    },
  ];

  // Process rows data
  const rows = users.map((user) => ({
    ...user,
  }));

  return {
    columns,
    rows,
  };
}

DeletedUsersDataTable.propTypes = {
  users: PropTypes.array.isRequired,
  t: PropTypes.func,
  language: PropTypes.string,
};

DeletedUsersDataTable.defaultProps = {
  t: null,
  language: "fr",
};
